import Marquee from 'react-fast-marquee'

import styles from './MarqueeText.module.scss'

const MarqueeText = () => {
  return (
    <Marquee className={styles.container}>
      <p className={styles.margueeText}>BREAK THE RULES. PLAY BY THE BOOK.</p>
    </Marquee>
  )
}

export default MarqueeText
